import { GameState } from '../types/game';

/**
 * Persistens för pågående singleplayer-spel ("Fortsätt spel" på startskärmen).
 *
 * Sparas löpande av YatzyGame och läses av startskärmen (YatzyGameManager).
 * Gäller inte: dagens utmaning (seedad RNG kan inte återupptas mitt i en
 * sekvens), serielägen (har egen persistens) eller challenge-läget.
 */

const RESUME_KEY = 'yatzy-active-game';
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000; // äldre sparningar än 7 dagar ignoreras

export interface SavedGame {
  modeId: string;
  gameState: GameState;
  gameStartTime: number;
  rollsUsedPerCategory: number[];
  savedAt: number;
  /** Kumulativ total per spelad omgång – behövs för ghost mode vid resume. */
  roundTotals?: number[];
}

export function saveGame(payload: SavedGame): void {
  try {
    localStorage.setItem(RESUME_KEY, JSON.stringify(payload));
  } catch {}
}

export function loadSavedGame(): SavedGame | null {
  try {
    const raw = localStorage.getItem(RESUME_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as SavedGame;
    if (!parsed || typeof parsed.modeId !== 'string' || !parsed.gameState) return null;
    if (!parsed.gameState.dice?.length || !parsed.gameState.scores) return null;
    if (parsed.gameState.isGameComplete) { clearSavedGame(); return null; }
    if (Date.now() - (parsed.savedAt || 0) > MAX_AGE_MS) { clearSavedGame(); return null; }
    return parsed;
  } catch {
    return null;
  }
}

export function clearSavedGame(): void {
  try { localStorage.removeItem(RESUME_KEY); } catch {}
}
